import { CategoryEnum, SortingEnum } from "@sprawdzonabron/shared";

import type { Filters } from "./types";

export const DEFAULT_FILTERS: Filters = {
  search: "",
  shop: [],
  caliber: [],
  voivodeship: [],
  available: [],
  producer: [],
  sorting: SortingEnum.Default,
  cityRange: "100km",
  category: CategoryEnum.All,
  excludedPhrases: [],
};
